import { Badge } from "@components";
import styles from "../../../styles/beneficios/BenefitCard.module.scss";
import { Button } from "../../components/Button";
import { Icon } from "../../components/core/Icon";
import { Currency } from "../../utils/Currency";
import { Numbers } from "../../utils/Numbers";
import dayjs from "dayjs";
import { useState } from "react";
import classNames from "classnames/bind";
import { If } from "shared/components/control-statements";
import { Environment } from "shared/core/Environment";
const css = classNames.bind(styles);

const st = (className) => styles[className];

export const BenefitCard = ({
  benefit,
  onOpenQrCode,
  onOpenDetails,
  onOpenOptions,
  onEditBenefit,
  onMoveBenefit,
  onArchiveBenefit,
  onFollowClients,
  onRedirectToChildrens,
}) => {
  const [collapsed, setCollapsed] = useState(false);

  return (
    <div className={st("benefit-card")}>
      <div className={st("header")}>
        <div className="d-flex align-center">
          <div className={st("icon-gift")}>
            <i className="fal fa-gift" />
          </div>
          <div className="d-flex align-center">
            <span className={st("code")}>{benefit.code}</span>
            <If cond={Environment.id !== 51}>
              {benefit?.pin && (
                <span className={st("pin")}>&nbsp;&nbsp;- {benefit.pin}</span>
              )}
            </If>
          </div>
        </div>

        <div className="d-flex align-center">
          {benefit?.template ? (
            <>
              <Badge
                type="success"
                name="Modelo"
                className={st("badge")}
                absolute={false}
              />
              <div className={st("separator")}></div>
            </>
          ) : null}

          <div className="d-flex gap-5">
            <Button
              design="default-icon-mini-4"
              onClick={() => onOpenDetails && onOpenDetails(benefit)}
            >
              <i className="fal fa-info-circle" />
            </Button>
            <Button
              design="default-icon-mini-4"
              onClick={() => onOpenQrCode && onOpenQrCode(benefit)}
            >
              <i className="fal fa-qrcode" />
            </Button>
          </div>

          {!benefit?.parent_id && (
            <>
              <div className={st("separator")}></div>
              <Button
                design="default-icon-mini-4"
                onClick={(e) => {
                  e.stopPropagation();
                  setCollapsed(!collapsed);
                }}
              >
                <i className="fal fa-ellipsis-v" />

                <div
                  className={css({
                    actions: true,
                    in: collapsed,
                    out: !collapsed,
                  })}
                >
                  <ul className={styles.options}>
                    <If cond={Environment.id === 51}>
                      <li onClick={() => onEditBenefit && onEditBenefit()}>
                        Editar benefício
                      </li>
                    </If>
                    <li onClick={() => onMoveBenefit && onMoveBenefit(benefit)}>
                      Mover benefício
                    </li>
                    <li
                      onClick={() =>
                        onArchiveBenefit && onArchiveBenefit(benefit)
                      }
                    >
                      Arquivar benefício
                    </li>
                    <li
                      onClick={() =>
                        onFollowClients && onFollowClients(benefit)
                      }
                    >
                      Contemplar clientes
                    </li>
                    <li
                      onClick={() =>
                        onRedirectToChildrens && onRedirectToChildrens(benefit)
                      }
                    >
                      Visualizar cupons
                    </li>
                  </ul>
                </div>
              </Button>
            </>
          )}
        </div>
      </div>

      <div className={st("content")}>
        <div className={st("infos")}>
          <div className={st("info")}>
            <p>Desconto</p>
            <span>{getBenefitValue(benefit)}</span>
          </div>

          <div className={st("info")}>
            <p>Pedido mínimo</p>
            <span>{Currency.formatCurrency(+benefit.min_order)}</span>
          </div>
        </div>

        <div className={st("infos")}>
          <div className={st("info")}>
            <p>Expiração</p>
            <span>
              {benefit.expiration_date
                ? dayjs(benefit.expiration_date).format("DD/MM/YYYY")
                : benefit.expiration_days
                  ? benefit.expiration_days + " dias"
                  : "-"}
            </span>
          </div>

          <div className={st("info")}>
            <p>Tipo de uso</p>
            <span>{getUseType(benefit)}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

const benefitTypes = {
  FREE_DELIVERY: "FREE_DELIVERY",
  CASH_DISCOUNT: "CASH_DISCOUNT",
  PERCENTAGE_DISCOUNT: "PERCENTAGE_DISCOUNT",
  CASHBACK: "CASHBACK",
  PRODUCT_DISCOUNT: "PRODUCT_DISCOUNT",
  PRODUCT_CASH_DISCOUNT: "PRODUCT_CASH_DISCOUNT",
};

const useTypes = {
  ONLINE: 1,
  OFFLINE: 2,
  TAKEAWAY: 4,
  FASTFILA: 8,
};

const getBenefitValue = (benefit) => {
  const programByPoint =
    localStorage.getItem("cashbackProgramType") === "POINT";

  const benefitType = benefit.type;
  switch (benefitType) {
    case benefitTypes.PERCENTAGE_DISCOUNT:
    case benefitTypes.CASHBACK:
      return programByPoint
        ? `${benefit.value} pontos para cada R$100`
        : `${benefit.value}%`;
    case benefitTypes.FREE_DELIVERY:
      return "Entrega grátis";
    case benefitTypes.PRODUCT_DISCOUNT:
      return `${Numbers.formatFloat(benefit.value)}% em produtos selecionados`;
    case benefitTypes.PRODUCT_CASH_DISCOUNT:
      return `${Currency.formatCurrency(
        +benefit.value,
      )} em produtos selecionados`;
    case benefitTypes.CASH_DISCOUNT:
    default:
      return Currency.formatCurrency(+benefit.value);
  }
};

const isType = (haystack, needle) => (needle & haystack) >= needle;

const getUseType = ({ type_use: useType }) => {
  const arr = [];

  if (isType(useType, useTypes.ONLINE)) {
    arr.push("Delivery");
  }

  if (isType(useType, useTypes.OFFLINE)) {
    arr.push("Salão");
  }

  if (isType(useType, useTypes.TAKEAWAY)) {
    arr.push("Para viagem");
  }

  if (isType(useType, useTypes.FASTFILA)) {
    arr.push("Consumo no local");
  }

  return arr.join(", ");
};
